import Vue from 'vue';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

import vueMoment from 'vue-moment';

import CountryFlag from 'vue-country-flag';
import browserDetect from 'vue-browser-detect-plugin';

import App from './App.vue';
import router from './router';
import store from './store';

import DataTable from './widgets/DataTable.vue';
import FormGroup from './widgets/FormGroup.vue';
import SelectNationality from './widgets/SelectNationality.vue';
import SelectPlayer from './widgets/SelectPlayer.vue';
import Paginator from './widgets/Paginator.vue';
import ErrorDisplay from './widgets/ErrorDisplay.vue';
import DetailedInformation from './widgets/DetailedInformation.vue';

import { default as msalPlugin } from 'vue-msal-browser';
const msalConfig = {
    auth: {
        tenant: 'ccebfe25-c6c1-436a-997d-5480160770b1',
        clientId: 'd7ce8657-6c47-45ed-9e7c-5a1eec2eeef2',
        authority: 'https://login.microsoftonline.com/ccebfe25-c6c1-436a-997d-5480160770b1',
        redirectUri: process.env.VUE_APP_AD_CALLBACK_URL,
        scopes: ['openid'],
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    mode: 'redirect',
};
Vue.use(msalPlugin, msalConfig);

import LogRocket from 'logrocket';
LogRocket.init('dns08a/wta-logrocket');

import './style.scss';

Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'small', locale });
Vue.use(vueMoment);
Vue.use(browserDetect);

Vue.component('country-flag', CountryFlag);
Vue.component('DataTable', DataTable);
Vue.component('FormGroup', FormGroup);
Vue.component('ErrorDisplay', ErrorDisplay);
Vue.component('DetailedInformation', DetailedInformation);
Vue.component('SelectNationality', SelectNationality);
Vue.component('SelectPlayer', SelectPlayer);
Vue.component('Paginator', Paginator);

import axios from 'axios';
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwt');
    config.headers['Authorization'] = `Bearer ${token}`;
    const accessToken = localStorage.getItem('accessToken');
    config.headers['X-Access-Token'] = accessToken;
    return config;
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

// eslint-disable-next-line no-console
console.log('Using environment: ', process.env.NODE_ENV);

// eslint-disable-next-line no-console
console.log('Using API URL: ', process.env.VUE_APP_API_URL);

// eslint-disable-next-line no-console
console.log('Using AD Callback URL: ', process.env.VUE_APP_AD_CALLBACK_URL);
